import {
  MemberEntryCard,
  MemberEntryCardFooter,
  MemberEntryCardHeader,
  MemberEntryCardLineup
} from '@bo-components/members/entries';
import type { FormattedNewWagers } from '@library/types/newWagers';
import { Loading } from '@library/components/Loading';
import { NoResults } from '@library/components/NoResults';
import { useMemo } from 'react';

export interface MemberEntriesCardsProps {
  isNewWagersLoading: boolean;
  newWagersData: FormattedNewWagers;
  noDataResults: boolean;
  onShowModal: (newWagerId: string) => void;
}

export const MemberEntriesCards = ({
  isNewWagersLoading,
  newWagersData,
  noDataResults,
  onShowModal
}: MemberEntriesCardsProps) => {
  const newWagersCards = useMemo(() => {
    return newWagersData.map(({ lineup, newWager }) => (
      <MemberEntryCard
        key={newWager.id}
        newWagerId={newWager.id}
        onShowModal={onShowModal}
      >
        <MemberEntryCardHeader lineup={lineup} newWager={newWager} />
        <MemberEntryCardLineup lineup={lineup} />
        <MemberEntryCardFooter newWager={newWager} />
      </MemberEntryCard>
    ));
  }, [onShowModal, newWagersData]);

  if (isNewWagersLoading && !newWagersData.length) {
    return <Loading loadingMessage="Loading Entries" />;
  }

  if (noDataResults) {
    return (
      <NoResults
        className="m-0 w-full"
        label="Use the search fields, dropdowns, or reset filters to find entries"
        dataTestId="no-entry-cards"
      />
    );
  }

  return (
    <>
      <div className="flex flex-wrap gap-4" data-testid="member-entry-cards">
        {newWagersCards}
      </div>
      {isNewWagersLoading && !!newWagersData.length && (
        <Loading loadingMessage="Loading Entries" />
      )}
    </>
  );
};
